import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

export const Home = () => (
  <SvgIcon viewBox="0 0 40 40">
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="square"
    >
      <g
        id="Icon/Dashboard"
        transform="translate(1.000000, 1.000000)"
        stroke="#FFFFFF"
        strokeWidth="2"
      >
        <g id="layout-right">
          <rect id="Rectangle" x="0" y="0" width="36" height="36"></rect>
          <path d="M0,10 L36,10 M12,10 L12,36" id="Shape"></path>
        </g>
      </g>
    </g>
  </SvgIcon>
);

export const Work = () => (
  <SvgIcon viewBox="0 0 38 38">
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="square"
    >
      <g id="Icon/Work" stroke="#FFFFFF" strokeWidth="2">
        <g id="tool" transform="translate(1.000000, 1.000000)">
          <path
            d="M14.539461,21.4900864 C13.5037207,21.7960321 12.4048904,21.9605371 11.2666359,21.9605371 C5.04424469,21.9605371 0,17.0445034 0,10.9802685 C0,9.28511076 0.394152571,7.67967235 1.09801247,6.24625221 L9.29450039,14.2344076 L14.6056435,9.0582594 L6.40915556,1.07010398 C7.87995956,0.384134282 9.52726808,0 11.2666359,0 C17.489027,0 22.5332717,4.91603367 22.5332717,10.9802685 C22.5332717,12.5914541 22.1772019,14.1215888 21.5375694,15.5 L34.9000262,28.5228279 C36.3666579,29.9521818 36.3666579,32.2696224 34.9000262,33.6989761 L33.638965,34.9279846 C32.1723335,36.3573385 29.7944537,36.3573385 28.327822,34.9279846 L14.539461,21.4900864 Z"
            id="Path"
          ></path>
        </g>
      </g>
    </g>
  </SvgIcon>
);

export const Requests = () => (
  <SvgIcon viewBox="0 0 38 37">
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="square"
    >
      <g
        id="Icon/request"
        transform="translate(1.000000, 1.000000)"
        stroke="#FFFFFF"
        strokeWidth="2"
      >
        <g id="chat-warning">
          <line x1="18" y1="6" x2="18" y2="14" id="Path"></line>
          <line x1="18" y1="19" x2="18" y2="20" id="Path"></line>
          <polygon
            id="Path"
            points="36 0 36 26 20 26 8 34 8 26 0 26 0 0"
          ></polygon>
          <line x1="18" y1="20" x2="18" y2="20" id="Path"></line>
        </g>
      </g>
    </g>
  </SvgIcon>
);

export const Recommendations = () => (
  <SvgIcon viewBox="0 0 32 34">
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="square"
    >
      <g
        id="Icon/recommendation"
        transform="translate(1.000000, 1.000000)"
        stroke="#FFFFFF"
        strokeWidth="2"
      >
        <g id="horn">
          <path
            d="M5,10 C8.66666666,10 12.3333334,10 16,10 C20,10 24.6666666,6.66666666 30,0 L30,30 C24.6666666,23.3333334 20,20 16,20 C12.3333334,20 8.66666666,20 5,20 L5,20 C2.23857626,20 0,17.7614238 0,15 L0,15 C0,12.2385762 2.23857626,10 5,10 Z"
            id="Path"
            strokeLinejoin="round"
          ></path>
          <polygon id="Path" points="6 20 10 32 18 32 14 20"></polygon>
          <line x1="14" y1="10" x2="14" y2="20" id="Path"></line>
        </g>
      </g>
    </g>
  </SvgIcon>
);

export const Locations = () => (
  <SvgIcon viewBox="0 0 38 40">
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Icon/Location"
        transform="translate(1.000000, 2.000000)"
        stroke="#FFFFFF"
        strokeWidth="2"
      >
        <g id="map">
          <polygon
            id="Path"
            strokeLinecap="square"
            points="12 32 0 36 0 4 12 0 24 4 36 0 36 31 24 36"
          ></polygon>
          <path
            d="M24,4 L24,36 M12,0 L12,32"
            id="Shape"
            strokeLinecap="round"
          ></path>
        </g>
      </g>
    </g>
  </SvgIcon>
);

export const Assets = () => (
  <SvgIcon viewBox="0 0 32 34">
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="square"
    >
      <g
        id="Icon/Asset"
        transform="translate(-1.000000, 1.000000)"
        stroke="#FFFFFF"
        strokeWidth="2"
      >
        <g id="wallpaper">
          <circle id="Oval" cx="17" cy="6" r="6"></circle>
          <circle id="Oval" cx="17" cy="26" r="6"></circle>
          <circle
            id="Oval"
            transform="translate(25.660200, 11.000100) rotate(60.000000) translate(-25.660200, -11.000100) "
            cx="25.6602"
            cy="11.0001"
            r="6"
          ></circle>
          <circle
            id="Oval"
            transform="translate(8.339740, 21.000200) rotate(60.000000) translate(-8.339740, -21.000200) "
            cx="8.33974"
            cy="21.0002"
            r="6"
          ></circle>
          <circle
            id="Oval"
            transform="translate(8.339700, 10.999900) rotate(-60.000000) translate(-8.339700, -10.999900) "
            cx="8.3397"
            cy="10.9999"
            r="6"
          ></circle>
          <circle
            id="Oval"
            transform="translate(25.660200, 20.999800) rotate(-60.000000) translate(-25.660200, -20.999800) "
            cx="25.6602"
            cy="20.9998"
            r="6"
          ></circle>
        </g>
      </g>
    </g>
  </SvgIcon>
);

export const Projects = () => (
  <SvgIcon viewBox="0 0 38 34">
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="square"
    >
      <g
        id="Color/White"
        transform="translate(1.000000, 1.000000)"
        stroke="#FFFFFF"
        strokeWidth="2"
      >
        <rect id="Rectangle" x="0" y="8" width="36" height="24"></rect>
        <rect id="Rectangle" x="10" y="0" width="16" height="32"></rect>
      </g>
    </g>
  </SvgIcon>
);

export const Quotes = () => (
  <SvgIcon width="24px" height="24px" viewBox="0 0 24 24">
    <g id="Icons" transform="translate(-29.000000, -179.000000)" fill="#FFFFFF">
      <g id="icons/getquote_white" transform="translate(25.000000, 175.000000)">
        <g id="Group-Copy" transform="translate(4.000000, 4.000000)">
          <path
            d="M12,0 C18.627417,0 24,5.372583 24,12 C24,18.627417 18.627417,24 12,24 C5.372583,24 0,18.627417 0,12 C0,5.372583 5.372583,0 12,0 Z M13.5173333,3.36 L11.2773333,3.36 L11.2773333,5.45066667 C10.12,5.64977778 9.18355556,6.10711111 8.468,6.82266667 C7.75244444,7.53822222 7.39466667,8.39377778 7.39466667,9.38933333 C7.39466667,10.248 7.60933333,10.9355556 8.03866667,11.452 C8.468,11.9684444 8.98133333,12.3511111 9.57866667,12.6 C10.176,12.8488889 10.9351111,13.0853333 11.856,13.3093333 C12.4906667,13.4711111 12.9791111,13.6111111 13.3213333,13.7293333 C13.6635556,13.8475556 13.9466667,14.0062222 14.1706667,14.2053333 C14.3946667,14.4044444 14.5066667,14.6595556 14.5066667,14.9706667 C14.5066667,15.4808889 14.3044444,15.876 13.9,16.156 C13.4955556,16.436 12.9137778,16.576 12.1546667,16.576 C10.8373333,16.576 9.60047619,16.2058095 8.44409524,15.4654286 L8.17866667,15.288 L7.24533333,17.36 C7.75555556,17.7582222 8.36222222,18.0817778 9.06533333,18.3306667 C9.65125926,18.5380741 10.2739136,18.6806667 10.9332963,18.7584444 L11.3333333,18.7973333 L11.3333333,20.8133333 L13.5733333,20.8133333 L13.5733333,18.7226667 C14.7431111,18.5235556 15.6733333,18.0786667 16.364,17.388 C17.0546667,16.6973333 17.4,15.848 17.4,14.84 C17.4,13.9937778 17.1915556,13.3217778 16.7746667,12.824 C16.3577778,12.3262222 15.8568889,11.9591111 15.272,11.7226667 C14.6871111,11.4862222 13.9466667,11.256 13.0506667,11.032 C12.4035556,10.8702222 11.8995556,10.7271111 11.5386667,10.6026667 C11.1777778,10.4782222 10.8791111,10.304 10.6426667,10.08 C10.4062222,9.856 10.288,9.56977778 10.288,9.22133333 C10.288,8.71111111 10.4902222,8.31288889 10.8946667,8.02666667 C11.2991111,7.74044444 11.8373333,7.59733333 12.5093333,7.59733333 C13.6302222,7.59733333 14.7618413,7.96752381 15.9041905,8.70790476 L16.168,8.88533333 L17.1013333,6.81333333 C16.7031111,6.45244444 16.1866667,6.15066667 15.552,5.908 C15.0442667,5.71386667 14.5086578,5.56552889 13.9451733,5.46298667 L13.5173333,5.39466667 L13.5173333,3.36 Z"
            id="Combined-Shape"
          ></path>
        </g>
      </g>
    </g>
  </SvgIcon>
);

export const Worktickets = () => (
  <SvgIcon viewBox="0 0 38 38">
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="square"
    >
      <g
        id="color/white"
        transform="translate(1.000000, 1.000000)"
        stroke="#FFFFFF"
        strokeWidth="2"
      >
        <g id="sticker">
          <path
            d="M36,0 L36,16 C36,27.045695 27.045695,36 16,36 L0,36 L0,0 L36,0 Z"
            id="Path"
          ></path>
          <path
            d="M12,36 C17.3333334,36 20,33.3333334 20,28 C20,28 20,25.3333334 20,20 L28,20 C33.3333334,20 36,17.3333334 36,12"
            id="Path"
          ></path>
        </g>
      </g>
    </g>
  </SvgIcon>
);

export const Forms = () => (
  <SvgIcon viewBox="0 0 38 34">
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="square"
    >
      <g
        id="icon/forms"
        transform="translate(1.000000, 1.000000)"
        stroke="#FFFFFF"
        strokeWidth="2"
      >
        <g id="inbox-alt">
          <polyline
            id="Path"
            points="0 18 12 18 12 24 24 24 24 18 36 18"
          ></polyline>
          <polygon id="Path" points="0 18 4 0 32 0 36 18 36 32 0 32"></polygon>
          <line x1="8" y1="6" x2="28" y2="6" id="Path"></line>
          <line x1="7" y1="12" x2="29" y2="12" id="Path"></line>
        </g>
      </g>
    </g>
  </SvgIcon>
);

export const Surveys = () => (
  <SvgIcon viewBox="0 0 32 42">
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="square"
    >
      <g
        id="Icon/Survey"
        transform="translate(2.000000, 2.000000)"
        stroke="#FFFFFF"
        strokeWidth="3"
      >
        <g id="clipboard">
          <polyline id="Path" points="20 2 28 2 28 38 0 38 0 2 8 2"></polyline>
          <path
            d="M18,4 L10,4 C8.8954305,4 8,3.1045695 8,2 C8,0.8954305 8.8954305,0 10,0 L18,0 C19.1045694,0 20,0.8954305 20,2 C20,3.1045695 19.1045694,4 18,4 Z"
            id="Path"
          ></path>
        </g>
      </g>
    </g>
  </SvgIcon>
);

export const Team = () => (
  <svg width="29px" height="25px" viewBox="0 0 29 25">
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Icons"
        transform="translate(-27.000000, -107.000000)"
        fill="#FFFFFF"
      >
        <g
          id="icons/icon_teammngmt"
          transform="translate(24.000000, 103.000000)"
        >
          <g id="Group-Copy-6" transform="translate(19.250000, 12.000000)">
            <g id="Group-Copy-2">
              <g id="Group-2">
                <g id="Group-Copy">
                  <path
                    d="M11,5.33333333 C11,8.2789699 8.53745765,10.6666667 5.5,10.6666667 C2.46231229,10.6666667 0,8.2789699 0,5.33333333 C0,2.38791986 2.46231229,0 5.5,0 C8.53745765,0 11,2.38791986 11,5.33333333 Z"
                    id="Stroke-1"
                  ></path>
                  <path
                    d="M0,16 C0.78967456,12.8936745 2.93086496,10.6666667 5.44824887,10.6666667 C8.02835802,10.6666667 10.2602528,12.7729239 11,16 L0,16 Z"
                    id="Stroke-3"
                    stroke="#FFFFFF"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </g>
              </g>
            </g>
          </g>
          <g id="Group-Copy-7" transform="translate(4.125000, 4.000000)">
            <g id="Group-Copy-2">
              <g id="Group-2">
                <g id="Group-Copy">
                  <path
                    d="M11,5.33333333 C11,8.2789699 8.53745765,10.6666667 5.5,10.6666667 C2.46231229,10.6666667 0,8.2789699 0,5.33333333 C0,2.38791986 2.46231229,0 5.5,0 C8.53745765,0 11,2.38791986 11,5.33333333 Z"
                    id="Stroke-1"
                  ></path>
                  <path
                    d="M0,16 C0.78967456,12.8936745 2.93086496,10.6666667 5.44824887,10.6666667 C8.02835802,10.6666667 10.2602528,12.7729239 11,16 L0,16 Z"
                    id="Stroke-3"
                    stroke="#FFFFFF"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const Quality = ({ fill = "#FFFFFF", width = "24px" }) => (
  <svg width={width} viewBox="0 0 24 30">
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Icons" transform="translate(-28.000000, -32.000000)" fill={fill}>
        <g id="icons/icons_quality" transform="translate(24.000000, 31.000000)">
          <g id="Group-7-Copy" transform="translate(4.000000, 1.333333)">
            <path
              d="M12.005311,23.9284224 C12.7745245,24.4860088 13.4632165,25.0315215 14.202475,25.4960853 C14.4503601,25.6519461 14.9263436,25.7433222 15.1178912,25.6085904 C15.3064159,25.4766027 15.3704483,24.9961235 15.3050418,24.7104703 C15.1461974,24.0167801 14.8342798,23.3579391 14.6809318,22.6639746 C14.6245943,22.40878 14.7551325,21.9966271 14.9499779,21.8245766 C15.5037347,21.3350421 16.1599983,20.9613055 16.7225492,20.4794543 C16.9256391,20.305483 17.1235076,19.9086966 17.056727,19.6982297 C16.990496,19.4894092 16.5961332,19.2808631 16.330385,19.2591853 C15.5916762,19.1996399 14.840051,19.2819607 14.1032659,19.2114392 C13.843014,19.1864686 13.4906983,18.9329204 13.3870922,18.69419 C13.0930377,18.0175129 12.9396897,17.2807415 12.658002,16.5977531 C12.5541211,16.3455769 12.2163707,15.9880301 12.0380143,16.0162936 C11.7755638,16.057454 11.4617225,16.3573762 11.3449251,16.6235469 C11.0698331,17.2505572 10.8766365,17.9170815 10.6919594,18.5792153 C10.5592226,19.0542064 10.3311243,19.2819607 9.80100181,19.247386 C9.11340904,19.2023839 8.41592285,19.1925054 7.73190271,19.2594597 C7.44224532,19.2879976 7.06107379,19.49133 6.93850529,19.7273164 C6.8574342,19.8842747 7.09652522,20.3145383 7.30428706,20.4923512 C7.84677632,20.9563663 8.43928232,21.3657752 9.03481131,21.7633848 C9.40141753,22.008152 9.51299333,22.2652674 9.3500267,22.6933357 C9.10516453,23.3357125 8.86854687,23.988791 8.72481745,24.6577849 C8.65886131,24.966488 8.72206927,25.4170573 8.91746434,25.625329 C9.0394832,25.7556703 9.57290349,25.6439884 9.82381165,25.485658 C10.5608715,25.0199966 11.2490139,24.4766791 12.005311,23.9284224 Z M9.77104673,29.3333333 C9.6622191,29.2268651 9.51601632,29.1393306 9.45006018,29.0109101 C8.86167644,27.8680227 8.0089185,27.2936977 6.64609974,27.3428158 C6.05551746,27.3642192 5.77025715,26.6749195 5.83786219,26.0701359 C5.93542232,25.199456 5.65510872,24.6575105 4.83010732,24.2620962 C3.95041729,23.8403391 3.76656455,23.1499418 4.29448849,22.3563691 C4.77926613,21.6278298 4.83175622,21.0455472 4.31619905,20.2964277 C3.75035033,19.4734938 3.95261583,18.8028535 4.87187954,18.3391129 C5.60729052,17.9681204 5.89474936,17.5008125 5.84555707,16.669921 C5.78234911,15.6063359 6.25998149,15.1436929 7.32764653,15.194183 C8.10675344,15.230953 8.59482889,15.0196629 8.96748108,14.2905748 C9.50804662,13.2335754 10.1178661,13.0727754 11.1028111,13.7052737 C11.7486317,14.1201707 12.2520969,14.1229147 12.8987419,13.7104874 C13.8875344,13.079361 14.5003769,13.237417 15.0390187,14.2886539 C15.4116709,15.0158212 15.8958989,15.2325994 16.6774791,15.1947318 C17.7465183,15.1425953 18.2241507,15.6052383 18.162042,16.6680002 C18.1133993,17.4988917 18.4008581,17.9642787 19.1357195,18.3371921 C20.0783427,18.8157505 20.246256,19.4693778 19.65375,20.366126 C19.19508,21.0600905 19.2137676,21.6023103 19.6674909,22.2891404 C20.2481797,23.1683268 20.0717471,23.8282654 19.1109859,24.3070982 C18.3546888,24.684402 18.1238424,25.1805222 18.1639657,25.9900103 C18.2150817,27.0140813 17.758885,27.4830356 16.7277707,27.436936 C15.873089,27.3985196 15.3278516,27.64411 14.9835056,28.4475613 C14.8381273,28.7869975 14.4915827,29.04082 14.2365523,29.3333333 L13.4390326,29.3333333 C11.8275042,28.2563026 12.1847667,28.2546561 10.5682916,29.3333333 L9.77104673,29.3333333 Z"
              id="Stroke-1"
            ></path>
            <path
              d="M17.8272187,0 C19.3430676,0.606877554 20.8580667,1.21489585 22.3747655,1.82034747 C22.628304,1.9215888 22.8945903,1.99459662 23.1416134,2.1098121 C23.9333902,2.47884384 24.2418857,3.2112036 23.7920318,3.9424226 C21.9203791,6.98593635 20.012466,10.0072055 18.1017202,13.0261932 C17.8022897,13.4993181 16.8799193,13.4017842 16.5068352,12.8984295 C15.3059973,11.2785684 14.4193205,11.0541263 12.5618319,11.8797422 C12.4065927,11.9487574 12.1887478,11.995528 12.0414405,11.9402018 C11.585921,11.7688045 11.1502313,11.5429366 10.6666667,11.3196353 C12.5513505,7.79871879 14.4249862,4.28521716 16.3190184,0.782552635 C16.4799233,0.484532408 16.7731215,0.258949633 17.0054138,0 L17.8272187,0 Z"
              id="Stroke-3"
            ></path>
            <path
              d="M6.91466607,0 C7.28659717,0.524205494 7.71073899,1.01851334 8.02063479,1.57774179 C8.89726939,3.15833098 9.74499161,4.75600454 10.5579067,6.37076248 C10.689837,6.63272286 10.7094862,7.08403503 10.5739068,7.33147369 C9.57769279,9.15209831 8.54807521,10.9547843 7.48870313,12.7381081 C7.00814007,13.5473379 6.14189147,13.5191486 5.64785468,12.7284269 C3.9072171,9.94196579 2.16826374,7.15436569 0.433520918,4.36420294 C-0.325779945,3.14295505 -0.101217768,2.46328176 1.21443589,1.96214017 C2.60896701,1.43053145 4.00574376,0.905756478 5.39746785,0.367029268 C5.64224063,0.27249574 5.8665221,0.1238617 6.10006677,0 L6.91466607,0 Z"
              id="Stroke-5"
            ></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const QualityTabIcon = (props) => (
  <svg
    width="24px"
    height="26px"
    viewBox="0 0 24 30"
    className={props.className}
  >
    <g
      id="Symbols"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Icons"
        transform="translate(-28.000000, -32.000000)"
        fill="currentColor"
      >
        <g id="icons/icons_quality" transform="translate(24.000000, 31.000000)">
          <g id="Group-7-Copy" transform="translate(4.000000, 1.333333)">
            <path
              d="M12.005311,23.9284224 C12.7745245,24.4860088 13.4632165,25.0315215 14.202475,25.4960853 C14.4503601,25.6519461 14.9263436,25.7433222 15.1178912,25.6085904 C15.3064159,25.4766027 15.3704483,24.9961235 15.3050418,24.7104703 C15.1461974,24.0167801 14.8342798,23.3579391 14.6809318,22.6639746 C14.6245943,22.40878 14.7551325,21.9966271 14.9499779,21.8245766 C15.5037347,21.3350421 16.1599983,20.9613055 16.7225492,20.4794543 C16.9256391,20.305483 17.1235076,19.9086966 17.056727,19.6982297 C16.990496,19.4894092 16.5961332,19.2808631 16.330385,19.2591853 C15.5916762,19.1996399 14.840051,19.2819607 14.1032659,19.2114392 C13.843014,19.1864686 13.4906983,18.9329204 13.3870922,18.69419 C13.0930377,18.0175129 12.9396897,17.2807415 12.658002,16.5977531 C12.5541211,16.3455769 12.2163707,15.9880301 12.0380143,16.0162936 C11.7755638,16.057454 11.4617225,16.3573762 11.3449251,16.6235469 C11.0698331,17.2505572 10.8766365,17.9170815 10.6919594,18.5792153 C10.5592226,19.0542064 10.3311243,19.2819607 9.80100181,19.247386 C9.11340904,19.2023839 8.41592285,19.1925054 7.73190271,19.2594597 C7.44224532,19.2879976 7.06107379,19.49133 6.93850529,19.7273164 C6.8574342,19.8842747 7.09652522,20.3145383 7.30428706,20.4923512 C7.84677632,20.9563663 8.43928232,21.3657752 9.03481131,21.7633848 C9.40141753,22.008152 9.51299333,22.2652674 9.3500267,22.6933357 C9.10516453,23.3357125 8.86854687,23.988791 8.72481745,24.6577849 C8.65886131,24.966488 8.72206927,25.4170573 8.91746434,25.625329 C9.0394832,25.7556703 9.57290349,25.6439884 9.82381165,25.485658 C10.5608715,25.0199966 11.2490139,24.4766791 12.005311,23.9284224 Z M9.77104673,29.3333333 C9.6622191,29.2268651 9.51601632,29.1393306 9.45006018,29.0109101 C8.86167644,27.8680227 8.0089185,27.2936977 6.64609974,27.3428158 C6.05551746,27.3642192 5.77025715,26.6749195 5.83786219,26.0701359 C5.93542232,25.199456 5.65510872,24.6575105 4.83010732,24.2620962 C3.95041729,23.8403391 3.76656455,23.1499418 4.29448849,22.3563691 C4.77926613,21.6278298 4.83175622,21.0455472 4.31619905,20.2964277 C3.75035033,19.4734938 3.95261583,18.8028535 4.87187954,18.3391129 C5.60729052,17.9681204 5.89474936,17.5008125 5.84555707,16.669921 C5.78234911,15.6063359 6.25998149,15.1436929 7.32764653,15.194183 C8.10675344,15.230953 8.59482889,15.0196629 8.96748108,14.2905748 C9.50804662,13.2335754 10.1178661,13.0727754 11.1028111,13.7052737 C11.7486317,14.1201707 12.2520969,14.1229147 12.8987419,13.7104874 C13.8875344,13.079361 14.5003769,13.237417 15.0390187,14.2886539 C15.4116709,15.0158212 15.8958989,15.2325994 16.6774791,15.1947318 C17.7465183,15.1425953 18.2241507,15.6052383 18.162042,16.6680002 C18.1133993,17.4988917 18.4008581,17.9642787 19.1357195,18.3371921 C20.0783427,18.8157505 20.246256,19.4693778 19.65375,20.366126 C19.19508,21.0600905 19.2137676,21.6023103 19.6674909,22.2891404 C20.2481797,23.1683268 20.0717471,23.8282654 19.1109859,24.3070982 C18.3546888,24.684402 18.1238424,25.1805222 18.1639657,25.9900103 C18.2150817,27.0140813 17.758885,27.4830356 16.7277707,27.436936 C15.873089,27.3985196 15.3278516,27.64411 14.9835056,28.4475613 C14.8381273,28.7869975 14.4915827,29.04082 14.2365523,29.3333333 L13.4390326,29.3333333 C11.8275042,28.2563026 12.1847667,28.2546561 10.5682916,29.3333333 L9.77104673,29.3333333 Z"
              id="Stroke-1"
            ></path>
            <path
              d="M17.8272187,0 C19.3430676,0.606877554 20.8580667,1.21489585 22.3747655,1.82034747 C22.628304,1.9215888 22.8945903,1.99459662 23.1416134,2.1098121 C23.9333902,2.47884384 24.2418857,3.2112036 23.7920318,3.9424226 C21.9203791,6.98593635 20.012466,10.0072055 18.1017202,13.0261932 C17.8022897,13.4993181 16.8799193,13.4017842 16.5068352,12.8984295 C15.3059973,11.2785684 14.4193205,11.0541263 12.5618319,11.8797422 C12.4065927,11.9487574 12.1887478,11.995528 12.0414405,11.9402018 C11.585921,11.7688045 11.1502313,11.5429366 10.6666667,11.3196353 C12.5513505,7.79871879 14.4249862,4.28521716 16.3190184,0.782552635 C16.4799233,0.484532408 16.7731215,0.258949633 17.0054138,0 L17.8272187,0 Z"
              id="Stroke-3"
            ></path>
            <path
              d="M6.91466607,0 C7.28659717,0.524205494 7.71073899,1.01851334 8.02063479,1.57774179 C8.89726939,3.15833098 9.74499161,4.75600454 10.5579067,6.37076248 C10.689837,6.63272286 10.7094862,7.08403503 10.5739068,7.33147369 C9.57769279,9.15209831 8.54807521,10.9547843 7.48870313,12.7381081 C7.00814007,13.5473379 6.14189147,13.5191486 5.64785468,12.7284269 C3.9072171,9.94196579 2.16826374,7.15436569 0.433520918,4.36420294 C-0.325779945,3.14295505 -0.101217768,2.46328176 1.21443589,1.96214017 C2.60896701,1.43053145 4.00574376,0.905756478 5.39746785,0.367029268 C5.64224063,0.27249574 5.8665221,0.1238617 6.10006677,0 L6.91466607,0 Z"
              id="Stroke-5"
            ></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const Training = () => (
  <svg height="24" viewBox="0 0 24 24" width="24">
    <path d="M0 0h24v24H0z" fill="none" />
    <path
      d="M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82zM12 3L1 9l11 6 9-4.91V17h2V9L12 3z"
      fill="#ffffff"
    />
  </svg>
);

export const Reports = () => (
  <svg height="24" viewBox="0 0 24 24" width="24">
    <path
      d="M5 9.2h3V19H5zM10.6 5h2.8v14h-2.8zm5.6 8H19v6h-2.8z"
      fill="#ffffff"
    />
    <path d="M0 0h24v24H0z" fill="none" />
  </svg>
);
